import styled from '@emotion/styled';
import COLORS from '@zola/zola-ui/src/styles/emotion/colorsBaby';
import MEDIA_QUERY from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';

export const ModalContainer = styled.div`
  display: flex;
  // padding: 72px 72px 48px 72px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: left;
`;

export const AppDownloadContainer = styled(LinkV2)`
  border: 1px solid ${COLORS.BLACK_030};
  border-radius: 16px;
  display: flex;
  padding: 16px 24px;
  align-items: center;
  gap: 24px;
  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    display: none;
  }
`;

export const DownloadText = styled.div`
  display: flex;
  flex-direction: column;
`;
